import { render } from "./Portfolio.vue?vue&type=template&id=896bf694&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"

import "./Portfolio.vue?vue&type=style&index=0&id=896bf694&scoped=true&lang=css"
import "./Portfolio.vue?vue&type=style&index=1&id=896bf694&lang=css"

import exportComponent from "C:\\wamp64\\www\\tafe-raap-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-896bf694"]])

export default __exports__